import * as React from 'react';

import BaseIcon from 'shared/newComponents/icons/BaseIcon';
import { CommonIconProps, IconSize } from 'shared/entities/components/Icon';

const MinusIcon: React.FC<CommonIconProps> = (props: CommonIconProps) => {
  return (
    <BaseIcon
      iconSize={IconSize.XM}
      svgProps={{
        viewBox: '0 0 20 20'
      }}
      {...props}
    >
      <path
        d="M3.33337 10H16.6667"
        stroke="currentColor"
        strokeWidth="1.66667"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

export default MinusIcon;
